import ButtonGroup2, { ButtonGroup2Props } from './ButtonGroup2';

export type { ButtonGroup2Props };
export default ButtonGroup2;
